import { LocalDate } from '../../core/model/local-date';

export class OpeningBalanceRun {
  constructor(data?: any) {
    if (!data) return;

    this.id = data.id;
    this.companyId = data.companyId;
    this.sourceKind = data.sourceKind;
    this.status = data.status;
    this.balanceDate = LocalDate.fromDate(data.balanceDate);
    this.closedToDate = LocalDate.fromDate(data.closedToDate);
    this.description = data.description;
    this.createdAtUtc = data.createdAtUtc;
  }

  id: string;
  companyId: string;
  sourceKind: string;
  status: string;
  balanceDate: LocalDate;
  closedToDate: LocalDate;
  description: string;
  createdAtUtc: string;
}

export class AccountingPeriodSkippedCompany {
  constructor(data?: any) {
    if (!data) return;

    this.companyId = data.companyId;
    this.companyName = data.companyName;
    this.accountingClosedTo = LocalDate.fromDate(data.accountingClosedTo);
  }

  companyId: string;
  companyName: string;
  accountingClosedTo: LocalDate;
}

export class AccountingPeriodCloseResult {
  constructor(data?: any) {
    if (!data) return;

    this.closedRuns = Array.isArray(data.closedRuns) ? data.closedRuns.map(run => new OpeningBalanceRun(run)) : [];
    this.alreadyClosedCompanies = Array.isArray(data.alreadyClosedCompanies)
      ? data.alreadyClosedCompanies.map(company => new AccountingPeriodSkippedCompany(company))
      : [];
  }

  closedRuns: OpeningBalanceRun[] = [];
  alreadyClosedCompanies: AccountingPeriodSkippedCompany[] = [];
}

export class AccountingPeriodReopenInfo {
  constructor(data?: any) {
    if (!data) return;

    this.canReopen = data.canReopen;
    this.currentClosedToDate = LocalDate.fromDate(data.currentClosedToDate);
    this.remainingClosedToDate = LocalDate.fromDate(data.remainingClosedToDate);
  }

  canReopen = false;
  currentClosedToDate: LocalDate;
  remainingClosedToDate: LocalDate;
}
